module.exports = __webpack_public_path__ + "img/img35.0f262a89.svg";